<div mat-dialog-title>{{ 'Report VSME' }}</div>

<div mat-dialog-content class="dialog-center-cont" style="padding: 0px !important">
  <app-spinner-overlay></app-spinner-overlay>
  <mat-stepper
    [linear]="!isPubblicato() && !isArchiviato()"
    #stepper
    (selectionChange)="cambioStep($event)"
  >
    <!-- STEP 1 -->
    <mat-step [stepControl]="formReportVsme">
      <ng-scrollbar [visibility]="'hover'">
        <ng-template matStepLabel>
          {{ 'Report VSME' }}
        </ng-template>
        <ng-container>
          <div appFormElement [larghezza]="12" [riempi]="true">
            <div class="titolo-sezione-dialog">Creazione Report VSME</div>
            <div class="descrizione-sezione-dialog">
              Lo standard volontario per le microimprese, le piccole e le medie imprese (VSME) non
              quotate
            </div>
          </div>
        </ng-container>
        @if (guidaDescrizione) {
          <div class="guida-descrizione">
            <mat-icon>error</mat-icon><span>{{ guidaDescrizione }}</span>
          </div>
        }
        <form
          class="form-step1"
          [formGroup]="formReportVsme"
          [alignItems]="'flex-start'"
          appFormContainer
          [larghezza]="12"
          [gap]="10"
          [rowGap]="5"
          style="align-items: center"
        >
          <div class="cnt-radio-message">
            <div class="cnt-radio">
              <!-- TIPO AZIENDA -->
              <div class="radio-cmp" appFormElement [larghezza]="2" [riempi]="true">
                <div class="radio-container">
                  <mat-label style="margin-left: 5px">Tipo Azienda</mat-label>
                  <div class="eti-check">
                    <mat-icon
                      class="info-icon"
                      [appTooltipOverlay]="tooltipTipoAzienda"
                      [variabiliTemplate]="{ tipoRadio: 'AZIENDA' }"
                      position="right"
                    >
                      info_outline
                    </mat-icon>
                  </div>
                </div>
                <mat-radio-group
                  aria-label="Tipo Azienda"
                  style="display: flex"
                  formControlName="tipoAzienda"
                >
                  <mat-radio-button
                    aria-label="Microimpresa"
                    value="MICROIMPRESA"
                    [disabled]="formReportVsme.get('id')?.value"
                  >
                    <span style="font-size: 13px"> Microimpresa </span>
                  </mat-radio-button>
                  <mat-radio-button
                    aria-label="PMI"
                    value="PMI"
                    [disabled]="formReportVsme.get('id')?.value"
                  >
                    <span style="font-size: 13px"> PMI </span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>

              <!-- TIPO VSME -->
              <div class="radio-cmp" appFormElement [larghezza]="2" [riempi]="true">
                <div class="radio-container">
                  <mat-label style="margin-left: 5px">Tipo Modulo VSME</mat-label>

                  <div class="eti-check">
                    <mat-icon
                      class="info-icon"
                      [appTooltipOverlay]="tooltipTipoAzienda"
                      [variabiliTemplate]="{ tipoRadio: 'VSME' }"
                      position="right"
                    >
                      info_outline
                    </mat-icon>
                  </div>
                </div>

                <mat-radio-group
                  class="radio-tipo-vsme"
                  aria-label="Tipo Modulo VSME"
                  style="display: flex"
                  formControlName="tipoVsme"
                >
                  <mat-radio-button
                    aria-label="Base"
                    value="BASE"
                    [disabled]="formReportVsme.get('id')?.value"
                  >
                    <span style="font-size: 13px"> Base </span>
                  </mat-radio-button>

                  <mat-radio-button
                    aria-label="Completo"
                    value="COMPLETO"
                    [disabled]="formReportVsme.get('id')?.value"
                  >
                    <span style="font-size: 13px"> Completo </span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
          <!-- ANNO -->
          <div appFormElement [larghezza]="6" class="anno-btn-documenti">
            <mat-form-field appFormElement [larghezza]="3" class="input-anno">
              <mat-label>Anno</mat-label>
              <mat-select
                formControlName="anno"
                placeholder="Anno"
                (selectionChange)="onSelectionChangeAnno($event)"
              >
                <mat-option
                  *ngFor="let anno of arrayAnni"
                  [value]="anno"
                  [disabled]="ctrAnniUtilizzati(anno)"
                  >{{ anno }}</mat-option
                >
              </mat-select>
            </mat-form-field>

            @if (this.isIntegrazioneAI) {
              <div style="margin-left: 8px">
                <button mat-flat-button (click)="openSelezioneDocumenti()" class="ai-button">
                  <mat-icon svgIcon="follia_gradient_svg" inline="true"></mat-icon>Seleziona
                  Documenti per l'IA
                </button>
              </div>
            }
          </div>
          <ng-container>
            <div appFormElement [larghezza]="12" [riempi]="true">
              <div class="titolo-sezione-dialog">Informazioni Aziendali</div>

              <div class="descrizione-sezione-dialog">
                Compila le informazioni dimensionali dell'azienda
              </div>
            </div>

            <mat-form-field appFormElement [larghezza]="4" [riempi]="true">
              <mat-label>Fatturato</mat-label>
              <input
                matInput
                placeholder="Fatturato"
                formControlName="fatturato"
                type="number"
                appInputNumber
                inputmode="numeric"
                min="0"
                max="999999999999"
                (keydown)="onKeyDown($event)"
              />
              <mat-error appFormError></mat-error>
            </mat-form-field>

            <mat-form-field appFormElement [larghezza]="4" [riempi]="true">
              <mat-label>Nr. Dipendenti</mat-label>
              <input
                matInput
                placeholder="Nr. Dipendenti"
                formControlName="nrDipendenti"
                type="number"
                appInputNumber
                min="0"
                max="2147483646"
                (keydown)="onKeyDownDip($event)"
                inputmode="numeric"
              />
              <mat-error appFormError></mat-error>
            </mat-form-field>
          </ng-container>
        </form>

        <mat-tab-group style="padding-right: 20px !important">
          <mat-tab label="Informazioni Vsme">
            <div class="contenuto-mat-tab">
              @if (showInfoFormVsme) {
                <app-info-form-vsme
                  #infoFormVsme
                  [infoFormVsme]="datiAziendaVsme"
                  [disableForm]="!!this.formReportVsme.get('id')?.value"
                  [isModulo]="true"
                ></app-info-form-vsme>
              } @else {
                <div class="spinner-container">
                  <mat-spinner diameter="40"></mat-spinner>
                </div>
              }
            </div>
          </mat-tab>
          @if (!isUtenteGo) {
            <mat-tab label="Inclusione Moduli">
              <div class="contenuto-mat-tab">
                <app-inclusione-moduli
                  [annoModulo]="this.formReportVsme.get('anno')?.value"
                  [idModulo]="this.formReportVsme.get('id')?.value"
                  [settore]="this.formReportVsme.get('settori')?.value"
                  [tipoModulo]="'REPORT_VSME'"
                  [idModuiliInclusi]="idModuliInclusi"
                ></app-inclusione-moduli>
              </div>
            </mat-tab>
          }
        </mat-tab-group>
      </ng-scrollbar>
    </mat-step>
    <!-- STEP 2 INFORMATIVA AZIENDALE -->
    <mat-step errorMessage="Campi obbligatori">
      <ng-template matStepLabel> Informativa </ng-template>
      <ng-scrollbar [visibility]="'hover'">
        <div appFormElement [larghezza]="3" [riempi]="true" style="padding-right: 20px !important">
          <div class="titolo-sezione-dialog">Informativa Aziendale</div>

          <div class="descrizione-sezione-dialog">
            L'informativa aziendale contiene dati rilevanti nella redazione del Report VSME, come ad
            esempio il periodo di rendicontazione, il campo di applicazione ed altri dati definiti
            dagli standard di reportistica. <br />
            Assegna la compilazione dell'informativa aziendale ad una figura aziendale tramite il
            pulsante
            <i>Figura</i> e notifica l'attività attraverso il pulsante <i>invia</i> , oppure
            compilala adesso attraverso il pulsante di <i>compilazione</i>. Monitora la compilazione
            da parte della figura aziendale attraverso il simbolo di <i>Stato</i>.
          </div>
          <div class="card-tabella mat-elevation-z2">
            <div class="cont-tabella">
              @if (arrayInformativa) {
                <table mat-table [dataSource]="arrayInformativa ? arrayInformativa : []">
                  <ng-container matColumnDef="figura">
                    <th mat-header-cell class="titolo-colonna" *matHeaderCellDef>
                      Figure Aziendali
                    </th>
                    <td mat-cell class="dati-righe" *matCellDef="let elem">{{ elem?.figura }}</td>
                  </ng-container>
                  <ng-container matColumnDef="nome">
                    <th mat-header-cell class="titolo-colonna" *matHeaderCellDef>Nome</th>
                    <td mat-cell class="dati-righe" *matCellDef="let elem">{{ elem?.nome }}</td>
                  </ng-container>
                  <ng-container matColumnDef="email">
                    <th mat-header-cell class="titolo-colonna" *matHeaderCellDef>Email</th>
                    <td mat-cell class="dati-righe" *matCellDef="let elem">{{ elem?.email }}</td>
                  </ng-container>
                  <ng-container matColumnDef="stato">
                    <th mat-header-cell class="titolo-colonna" *matHeaderCellDef>Stato</th>
                    <td mat-cell class="dati-righe" *matCellDef="let elem">
                      <!-- {{ elem?.stato }} -->

                      <div *ngIf="elem?.stato === 'ROSSO'" class="rosso"></div>
                      <div *ngIf="elem?.stato === 'GIALLO'" class="giallo"></div>
                      <div *ngIf="elem?.stato === 'VERDE'" class="verde"></div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="azioni">
                    <th
                      mat-header-cell
                      class="titolo-colonna"
                      *matHeaderCellDef
                      style="text-align: right"
                    >
                      Azioni
                    </th>
                    <td mat-cell class="dati-righe" *matCellDef="let elem">
                      <div
                        appFormElement
                        [larghezza]="0"
                        [minWidth]="50"
                        style="display: flex; justify-content: end; column-gap: 10px"
                      >
                        <button
                          class="icone-button"
                          mat-icon-button
                          (click)="compilazione(elem)"
                          [title]="
                            elem?.stato === 'VERDE' || isPermessoSoloReadFunx()
                              ? 'Visualizza'
                              : 'Compila'
                          "
                          [attr.aria-label]="
                            elem?.stato === 'VERDE' || isPermessoSoloReadFunx()
                              ? 'Visualizza'
                              : 'Compila'
                          "
                        >
                          <mat-icon class="icone">
                            {{
                              elem?.stato === 'VERDE' || isPermessoSoloReadFunx()
                                ? 'visibility'
                                : 'history_edu'
                            }}
                          </mat-icon>
                        </button>
                        @if (!isArchiviato()) {
                          <button
                            class="icone-button"
                            mat-icon-button
                            (click)="figura(elem)"
                            title="Figura"
                            [attr.aria-label]="'Figura'"
                            *ngIf="elem.stato !== 'VERDE' && !isPermessoSoloReadFunx()"
                          >
                            <mat-icon class="icone"> person </mat-icon>
                          </button>
                          <button
                            class="icone-button"
                            mat-icon-button
                            (click)="inviaMailInformativa(elem)"
                            title="Invia"
                            *ngIf="
                              !elem.ultimoInvio && elem.stato !== 'VERDE' && isPermessoInvioMail
                            "
                            [attr.aria-label]="'Invia'"
                          >
                            <mat-icon class="icone"> mail </mat-icon>
                          </button>
                          <button
                            class="icone-button"
                            mat-icon-button
                            (click)="inviaNotifInformativa(elem)"
                            title="Notifica"
                            *ngIf="
                              elem.ultimoInvio !== '' &&
                              elem.stato !== 'VERDE' &&
                              isPermessoInvioMail
                            "
                            [attr.aria-label]="'Notifica'"
                          >
                            <mat-icon class="icone"> notifications_active </mat-icon>
                          </button>

                          <!-- STAMPA INFORMATIVA -->
                          <button
                            class="icone-button"
                            mat-icon-button
                            (click)="stampaInformativa()"
                            title="Anteprima"
                            *ngIf="elem.stato !== 'VERDE' && isPermessoStama"
                          >
                            <mat-icon class="icone"> print </mat-icon>
                          </button>
                        }
                      </div>
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumns; sticky: true"
                    class="riga-colonna"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    class="riga-riga"
                  ></tr>
                </table>
              }
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </mat-step>

    <!-- STEP SELEZIONE TEMATICHE -->
    <mat-step errorMessage="Campi obbligatori">
      <ng-template matStepLabel> Tematiche </ng-template>
      <div style="padding-right: 20px !important; height: 100%">
        <app-cfg-questionario
          #surveyComp
          [isPermessoSoloRead]="isPermessoSoloReadFunx()"
          [tipoQuestionario]="'REPORT_VSME'"
          [cfgQuestionario]="reportVsme"
          [idSostenibilita]="formReportVsme.get('id')?.value"
          [nascondiTitolo]="true"
        ></app-cfg-questionario>
      </div>
    </mat-step>

    <!-- STEP COMPILAZINE TEMATICHE -->
    <mat-step errorMessage="Campi obbligatori">
      <ng-template matStepLabel> Informativa VSME </ng-template>
      <div class="cnt-titolo-compila-risposta">
        <div class="titolo-sezione-dialog">Compilazione dell’informativa VSME</div>

        <div class="descrizione-sezione-dialog">
          In questa sezione, per ciascuna tematica di sostenibilità selezionata, è possibile
          compilare le informazioni aziendali in coerenza con lo standard VSME, includendo impegni,
          azioni e buone pratiche, indicatori e target di sostenibilità.
        </div>

        @if (compilaTematiche?.ambiti?.length) {
          <app-compila-report-vsme
            #cmpCompilaVsme
            [idModulo]="formReportVsme.get('id')?.value ?? ''"
            [compilazione]="compilaTematiche"
            [readOnly]="isPubblicato() || isArchiviato()"
            (completato)="finitaCompilazione($event)"
          >
          </app-compila-report-vsme>
        }
      </div>
    </mat-step>
    <!--  ---------------------- C R U S C O T T O ---------- -->
    <mat-step>
      <ng-template matStepLabel> Cruscotto </ng-template>
      <div class="barra-titolo-cruscotto">
        <div style="display: flex; flex-direction: column; flex: 1">
          <div class="titolo-sezione-dialog">Cruscotto Report VSME</div>

          <div class="descrizione-sezione-dialog">
            Visualizza e gestisci ogni aspetto relativo alla compilazione: avanzamento,
            configurazione dei testi mail, invio e notifiche.
          </div>
        </div>
        <!-- TOTALI CRUSCOTTO -->
        @if (idReportVsme) {
          <app-totali-cruscotto
            #totaliCruscotto
            [idModulo]="idReportVsme"
            [tipoModulo]="'REPORT_VSME'"
          >
          </app-totali-cruscotto>
        }
      </div>
      <ng-scrollbar>
        <div style="padding-right: 20px">
          <app-lista-tabellare
            #tabellaCruscotto
            [defaultPageSize]="4"
            [fnCaricamentoDati]="fnCaricamentoDatiCruscotto"
            [colonne]="colonne"
            [maxNrButton]="1"
            [filtri]="filtri"
            (bottoniListaClick)="bottoniListaClick($event)"
            *ngIf="this.formReportVsme.get('id')?.value"
          >
            <ng-container btnEnd>
              <button
                [disabled]="!isPermessoInvioMail"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="template()"
              >
                <mat-icon matSuffix>settings</mat-icon>
                Config. Testi
              </button>

              <button
                [disabled]="!isPermessoInvioMail || isArchiviato()"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="inviaTutti()"
              >
                <mat-icon matSuffix>mail</mat-icon>
                Invia a Tutti
              </button>

              <button
                [disabled]="!isPermessoInvioMail || isArchiviato()"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="notificaTutti()"
              >
                <mat-icon matSuffix>notifications_active</mat-icon>
                Notifica Tutti
              </button>
            </ng-container>
          </app-lista-tabellare>
        </div>
      </ng-scrollbar>
    </mat-step>
    <!--  ---------------------- S T A M P A ---------- -->
    <mat-step>
      <ng-template matStepLabel> Configurazione Stampa </ng-template>

      <app-cfg-stampa
        [isPermessoSoloRead]="isPermessoSoloReadFunx()"
        [fnGetConfigStampa]="fnGetConfigStampa"
        style="padding-right: 20px"
        [fnSalvaCfgStampa]="fnSalvaCfgStampa"
        [fnCaricaImg]="fnImportaImmagine"
        [fnEliminaImg]="fnEliminaImg"
        (loading)="toggleLoading($any($event))"
        [titolo]="'Seleziona e compila gli elementi che compongono il Report VSME dell\'azienda'"
      ></app-cfg-stampa>
    </mat-step>
  </mat-stepper>
</div>

<!------------------------ FOOTER ------------------------->
<div mat-dialog-actions class="dialog-footer-cont">
  @if (stepper.selectedIndex === 0) {
    <button mat-flat-button color="accent" matDialogClose class="accent-button">Chiudi</button>
  } @else {
    <div>
      <button mat-flat-button color="accent" (click)="indietro()" class="accent-button">
        Indietro
      </button>
    </div>
  }

  @if (
    stepper.selectedIndex !== 5 &&
    (stepper.selectedIndex !== 3 ||
      (stepper.selectedIndex === 3 && (isPubblicato() || isArchiviato())))
  ) {
    <button
      mat-flat-button
      color="primary"
      (click)="avantiHTML()"
      class="primary-button"
      #btnAvanti
    >
      Avanti
    </button>
  }

  <!-- ----- BOTTONI STEP COMPILA RISPOSTE TEMATICHE  ------ -->
  @if (stepper.selectedIndex === 3 && cmpCompilaVsme) {
    <div class="cnt-nav-tem-button">
      <div>
        <button
          [disabled]="cmpCompilaVsme.currentSlideIndex < 1"
          mat-flat-button
          color="accent"
          (click)="cmpCompilaVsme.indietro()"
          class="accent-button nav-tem-button"
        >
          Tematica Precedente
        </button>
      </div>

      <!-- Visualizzo il bottone "Fine compilazione" solamente se non sono in Pubblicato-->
      @if (
        !(
          (isPubblicato() || isArchiviato()) &&
          cmpCompilaVsme.currentSlideIndex + 1 === cmpCompilaVsme.totTematiche
        )
      ) {
        <button
          mat-flat-button
          color="primary"
          (click)="avantiTematica()"
          class="primary-button nav-tem-button"
          #btnAvanti
          [disabled]="disabilitaBtnTematicaNext()"
        >
          {{
            cmpCompilaVsme.currentSlideIndex + 1 === cmpCompilaVsme.totTematiche
              ? 'Fine'
              : 'Tematica Successiva'
          }}
        </button>
      }
    </div>
    <div class="index-paginator">
      {{ cmpCompilaVsme.swiperPaginator }}
    </div>
  }
  <!-- ----- BOTTONI STEP STAMPA REPORT ------ -->
  <ng-container *ngIf="stepper.selectedIndex === 5">
    <button
      *ngIf="!isPermessoSoloReadFunx()"
      mat-flat-button
      color="primary"
      (click)="salvaCfgStampa()"
      class="primary-button"
    >
      Salva
    </button>
    <button
      *ngIf="isPermessoSoloReadFunx()"
      mat-flat-button
      color="accent"
      matDialogClose
      class="accent-button"
    >
      Chiudi
    </button>
    <button
      [disabled]="!this.cfgStampaComponent.isPermessoStampa"
      mat-flat-button
      color="accent"
      (click)="stampa()"
      class="accent-button"
      style="margin: 0 !important"
    >
      <mat-icon class="material-icons-outlined"> print </mat-icon>
      Stampa
    </button>
  </ng-container>
  <!-- ------------------------------------------------ -->
</div>

<!-- WIDGET CHAT AI FOLLIA: visualizzato solo dopo l'apertura completa della dialog (afterOpened) -->
@if (showChatWidget) {
  <app-app-follia-widget></app-app-follia-widget>
}

<ng-template #tooltipTipoAzienda let-tipoRadio="tipoRadio">
  <div>
    @if (tipoRadio === 'VSME') {
      <ul style="padding-left: 1rem; margin: 0">
        <li>
          <span style="color: var(--mat-color-accent); font-weight: 600">Modulo base</span><br />

          <span style="font-size: 12px">
            Gli orientamenti che seguono sono intesi come parte di un ecosistema che comprenderà
            anche lo sviluppo di ulteriori guide di supporto da parte dell'EFRAG, ulteriori
            strumenti digitali e supporto all'attuazione (attività educative, coinvolgimento dei
            portatori di interessi) che mirano a facilitare la comprensione di alcuni degli elementi
            tecnici degli orientamenti. </span
          ><br /><br />
          <span style="font-size: 12px">
            Include le disclosures B1 e B2 e le metriche di base da B3 a B11.<br />
            È l'approccio raccomandato per le microimprese e rappresenta il requisito minimo per
            tutte le altre imprese.
          </span>
        </li>
        <li style="margin-top: 0.8rem">
          <span style="color: var(--mat-color-accent); font-weight: 600">Modulo completo</span
          ><br />
          <span style="font-size: 12px">
            Questo modulo fornisce informazioni per soddisfare in modo completo le esigenze di
            informazione dei partner commerciali dell'impresa, quali investitori, banche e clienti
            aziendali, in aggiunta a quelle incluse nel modulo di base. Le informazioni contenute in
            questo modulo riflettono i rispettivi obblighi dei partecipanti ai mercati finanziari e
            dei clienti aziendali ai sensi delle leggi e dei regolamenti pertinenti. Esse riflettono
            inoltre le informazioni necessarie ai partner commerciali per valutare il profilo di
            rischio di sostenibilità dell'impresa, ad esempio in qualità di (potenziale) fornitore o
            (potenziale) mutuatario. </span
          ><br /><br />
          <span style="font-size: 12px">
            Comprende tutti i punti dati del modulo base (B1-B11) e ulteriori informazioni
            aggiuntive,<br />
            che saranno probabilmente richieste alle imprese di dimensioni maggiori.
          </span>
        </li>
      </ul>
    } @else {
      <ul style="padding-left: 1rem; margin: 0">
        <li>
          <span style="color: var(--mat-color-accent); font-weight: 600">Microimpresa</span><br />
          <span style="font-weight: 500; font-size: 13px">
            Un'impresa è considerata micro se non supera due delle seguenti soglie:
          </span>
          <ul style="padding-left: 1.2rem; margin: 0.3rem 0; font-size: 12px">
            <li>450.000 € di totale di bilancio</li>
            <li>900.000 € di fatturato netto</li>
            <li>Media di 10 dipendenti</li>
          </ul>
        </li>
        <li style="margin-top: 0.8rem">
          <span style="color: var(--mat-color-accent); font-weight: 600">Piccola impresa</span
          ><br />
          <span style="font-weight: 500; font-size: 13px">
            Un'impresa è considerata piccola se non supera due delle seguenti soglie:
          </span>
          <ul style="padding-left: 1.2rem; margin: 0.3rem 0; font-size: 12px">
            <li>5 milioni € di bilancio complessivo</li>
            <li>10 milioni € di fatturato netto</li>
            <li>Media di 50 dipendenti</li>
          </ul>
        </li>
        <li style="margin-top: 0.8rem">
          <span style="color: var(--mat-color-accent); font-weight: 600">Media impresa</span><br />
          <span style="font-weight: 500; font-size: 13px">
            Un'impresa è considerata media se non supera due delle seguenti soglie:
          </span>
          <ul style="padding-left: 1.2rem; margin: 0.3rem 0; font-size: 12px">
            <li>25 milioni € di totale di bilancio</li>
            <li>50 milioni € di fatturato netto</li>
            <li>Media di 250 dipendenti</li>
          </ul>
        </li>
      </ul>
    }
  </div>
</ng-template>
